import { Box } from "@mui/material";
import { styled } from "@mui/system";

interface MissionCardProps {
    color?: 'info' | 'primary';
}

export const MissionCard = styled(Box, {
    name: 'MissionCard',
})<MissionCardProps>(({theme, color}) => ({
    display: 'flex',
    flexGrow: 1,
    maxWidth: '256px',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: '0.75rem 1rem',
    height: '80px',
    backgroundColor: theme.palette.background.default,
    borderRadius: '0.5rem',
    ...(color === 'info' && {
        backgroundColor: theme.palette.info.main,
        color: theme.palette.info.contrastText,
    }),
}));